const SERVER = window.location.hostname === '0.0.0.0' || window.location.hostname === 'localhost'
export const FINANCE_SERVER = SERVER
  ? 'http://localhost:3000/api/'
  : `${window.location.protocol}//${window.location.hostname}/api/`



// WEBPACK FOOTER //
// ./src/constants/domains.js